
class ExpressUtils{
  static isExpress(indicacao):boolean{
    return indicacao?.tipoProduto === 'EXPRESS';
  }
}

export default ExpressUtils;
